'use client'

import { useOptimisticAvailability } from '../../../product-context/product-optimistic-context'
import type { ProductPageType } from '@productsite-beta/src/components/product-page-v2'
import ProductAvailabilityContainer from './product-availability'

type Props = {
  availability: ProductPageType['availability']
  isBid: boolean
}

const ProductAvailabilityOptimistic = ({ availability, isBid }: Props) => {
  const { optimisticAvailability } = useOptimisticAvailability()

  return (
    <ProductAvailabilityContainer
      availability={optimisticAvailability ?? availability}
      isBid={isBid}
    />
  )
}

export default ProductAvailabilityOptimistic
